import {Subject} from 'rxjs';
import {Component, OnDestroy} from '@angular/core';


@Component({
  standalone: false,
  template: ''
})
export abstract class BaseComponent implements OnDestroy {
  protected dest$ = new Subject<any>();

  ngOnDestroy(): void {
    this.dest$.next({});
    this.dest$.complete();
    this.onDestroy();
  }

  protected onDestroy(): void {}
}
